<template>
    <div>
        <q-card flat bordered class="q-px-md bg-grey-3"  style="border-radius: 20px">
            <q-card-section class="">
                <div class="row justify-center" >
                    <div class="col-6 column items-center">
                        <q-input class="text-body1" label='Investor' :value="this.InvestorName" readonly borderless/>
                    </div>
                    <div class="col-6 column items-center">
                        <q-input  class="text-body1" label='Reference ID' :value="this.ReferenceID" readonly borderless/>
                    </div>
                </div>
              <div class="row justify-center" >
                    <div class="col-6 column items-center">
                        <q-input  class="text-body1" label='Account Number' :value="this.AccountNo" readonly borderless/>
                    </div>
                    <div class="col-6 column items-center">
                        <q-input  class="text-body1" label='Account Type' :value="this.AccountType" readonly borderless/>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>

export default {
    name : 'GateWayFail',
    components : {
    },
    data() {
        return {
        }
    },
    props: {
        InvestorName:String,
        ReferenceID:String,
        AccountNo:String,
        AccountType:String
    }, 
    mounted(){

    },
    computed: {

    },
    methods: {
        

    }
}
</script>